import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Trans, useTranslation } from 'react-i18next';

const ResetTwoFactorAuthenticationModal = ({ open, onClose }: Props) => {
  const { i18n } = useTranslation();

  const handleRedirect = () => {
    const url =
      i18n.language === 'sv'
        ? 'https://info.avonova.se/sv/portal/mfa-reset'
        : 'https://info.avonova.se/eng/portal/mfa-reset';
    window.open(url, '_blank');
  };

  return (
    <Modal isOpen={open} toggle={onClose}>
      <ModalHeader toggle={onClose}>
        <Trans i18nKey="modals.resetTwoFactorAuthenticationPrompt" ns="translation" />
      </ModalHeader>
      <ModalBody>
        <Trans i18nKey="modals.resetTwoFactorAuthenticationMessage" ns="translation" />
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={handleRedirect}
        >
          <Trans i18nKey="modals.resetTwoFactorAuthenticationConfirm" ns="translation" />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

type Props = {
  open: boolean;
  onClose: () => void;
};

export default ResetTwoFactorAuthenticationModal;
